import {
  getAvailableResolutions,
  type OrderOpt,
  type VariantCollection,
} from "../lib/resolutions.lib";
import type { OrderLineItem, Resolution } from "../types";
import { usePublicShop } from "../queries/use-public-shop";
import { useIsMerchant } from "./use-is-merchant";

export function useAvailableResolutions(
  shopId: string,
  lineItem: OrderLineItem,
  variantCollection?: VariantCollection | null,
  opt?: OrderOpt | null,
): Resolution[] {
  const { data: shop } = usePublicShop(shopId);
  const isMerchant = useIsMerchant();
  return getAvailableResolutions(shop, lineItem, variantCollection, opt, {
    isMerchant,
  });
}
